import { render } from "./SummerSaleOffer.vue?vue&type=template&id=455a07ff&scoped=true"
import script from "./SummerSaleOffer.vue?vue&type=script&setup=true&lang=js"
export * from "./SummerSaleOffer.vue?vue&type=script&setup=true&lang=js"

import "./SummerSaleOffer.vue?vue&type=style&index=0&id=455a07ff&scoped=true&lang=scss"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455a07ff"],['__file',"src/views/paywall/SummerSaleOffer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "455a07ff"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('455a07ff', __exports__)) {
    console.log('reload')
    api.reload('455a07ff', __exports__)
  }
  
  module.hot.accept("./SummerSaleOffer.vue?vue&type=template&id=455a07ff&scoped=true", () => {
    console.log('re-render')
    api.rerender('455a07ff', render)
  })

}


export default __exports__